import { RadioGroup } from '@anyui/core';
import { cn } from '@anytag/shared-utils';
import { useSelectItem } from '@anytag/shared-hooks';
import { TikTokProductCategory } from '@anytag/graphql';
import { Radio, TextCutter, Icon } from '@anytag/shared-atoms';
import { useTikTokProductCategories } from '@anytag/shared-organisms';

type ProductCategoriesListProps = ReturnType<typeof useSelectItem<TikTokProductCategory>>;

export const ProductCategoriesList = ({ selectedItem, setSelectedItem }: ProductCategoriesListProps) => {
  const { productCategories } = useTikTokProductCategories();

  return (
    <RadioGroup
      value={selectedItem?.name}
      onChange={(name) =>
        setSelectedItem(productCategories.find((productCategory) => productCategory.name === name) || null)
      }
    >
      <div className={cn('grid w-full auto-rows-[1fr] grid-cols-3 gap-4')}>
        {productCategories.map((productCategory, index) => {
          const { icon, name, label } = productCategory;

          return (
            <div key={index} className={cn('box-border basis-1/3')}>
              <Radio
                value={name}
                classNames={{ label: 'h-full pr-4' }}
                className={cn(
                  'box-border flex h-20 grid-cols-[max-content_auto]! items-center gap-2 rounded-[12px] border-base-border bg-white',
                  'transition-[box-shadow_0.15s_ease-in-out] hover:shadow-[0px_5px_15px_1.5px_rgba(0,0,0,0.3)]',
                  "[&_[role='radio']]:box-border [&_[role='radio']]:h-full [&_[role='radio']]:w-max [&_[role='radio']]:items-center [&_[role='radio']]:pl-4"
                )}
                label={
                  <div className="box-border flex h-full items-center gap-1">
                    <TextCutter className="flex-1 text-base leading-none" text={label} />
                    <Icon icon={icon} size={24} variant="gray" />
                  </div>
                }
              />
            </div>
          );
        })}
      </div>
    </RadioGroup>
  );
};
